module.exports = __webpack_public_path__ + "static/media/notification.e6366527.svg";